// Angular
import { Injectable } from '@angular/core';

// Libraries
import _isEqual from 'lodash-es/isEqual';
import _get from 'lodash-es/get';

// Afidium
import { BreadcrumbService } from 'libraries/service/breadcrumb/breadcrumb.service';
import { IBreadcrumbItem } from 'libraries/service/breadcrumb/IBreadcrumbItem';
import { BookingSearchParameters } from 'app_sasha/shared/models/BookingSearchParameters';
import { SashaEntryPoints } from 'app_sasha/sasha-entry-points';
import { ProcessingSearchParameters } from "app_sasha/shared/models/ProcessingSearchParameters";

import { Yii } from "libraries/interfaces/Yii";
import { ILabels } from "libraries/interfaces/ILabels";
import { IBookingInTicketingReportSearchParametersUrl } from "app_sasha/pages/booking-in-ticketing-report/BookingInTicketingReportSearchParameters";

enum Actions {
    Search = "search",
    Results = "results",
    Booking = "booking",
    Processing = "processing",
    QualityCheck = "qualityCheck",
    Issue = "issue",
    Cancel = 'cancel',
    Void = 'void',
    import = 'import'
}

@Injectable()
export class SashaBreadcrumbService {

    //////////////////////////////////// SERVICE VARIABLES ////////////////////////////////////

    private context: string;

    private labels: ILabels = {
        [Actions.Search]: Yii.t('wui-sasha-js', 'Recherche'),
        [Actions.Results]: Yii.t('wui-sasha-js', 'Résultats de recherche'),
        [Actions.Booking]: Yii.t('wui-sasha-js', 'Dossier'),
        [Actions.Processing]: Yii.t('wui-sasha-js', 'Traitement'),
        [Actions.Issue]: Yii.t('wui-sasha-js', 'Émission'),
        [Actions.Cancel]: Yii.t('wui-sasha-js', 'Annulation'),
        [Actions.Void]: Yii.t('wui-sasha-js', 'Void'),
        [Actions.import]: Yii.t('wui-sasha-js', 'Import'),
    };

    /*** BOOKING VARS ***/
    private bookingSearchItem: IBreadcrumbItem = {
        name: this.labels[Actions.Search],
        isActive: false,
        isClickable: false,
        action: Actions.Search,
        routerLink: ['/sasha', 'booking', 'search'],
    };

    private bookingResultItem: IBreadcrumbItem = {
        name: this.labels[Actions.Results],
        isActive: false,
        isClickable: false,
        action: Actions.Results,
        routerLink: ['/sasha', 'booking', 'search-result'],
    };

    private bookingItem: IBreadcrumbItem = {
        name: this.labels[Actions.Booking],
        isActive: false,
        isClickable: false,
        action: Actions.Booking,
    };

    /*** BOOKING VARS ***/
    private processingSearchItem: IBreadcrumbItem = {
        name: this.labels[Actions.Search],
        isActive: false,
        isClickable: false,
        action: Actions.Search,
        routerLink: ['/sasha', 'processing', 'search'],
    };

    private processingResultItem: IBreadcrumbItem = {
        name: this.labels[Actions.Results],
        isActive: false,
        isClickable: false,
        action: Actions.Results,
        routerLink: ['/sasha', 'processing', 'search-result'],
    };


    private processingItem: IBreadcrumbItem = {
        name: this.labels[Actions.Processing],
        isActive: false,
        isClickable: false,
        action: Actions.Processing,
    };

    private processingQualityCheckItem: IBreadcrumbItem = {
        name: this.labels[Actions.QualityCheck],
        isActive: false,
        isClickable: false,
        action: Actions.QualityCheck,
    };

    private processingIssueItem: IBreadcrumbItem = {
        name: this.labels[Actions.Issue],
        isActive: false,
        isClickable: false,
        action: Actions.Issue,
    };

    private processingCancelItem: IBreadcrumbItem = {
        name: this.labels[Actions.Cancel],
        isActive: false,
        isClickable: false,
        action: Actions.Cancel,
    };

    private processingVoidItem: IBreadcrumbItem = {
        name: this.labels[Actions.Void],
        isActive: false,
        isClickable: false,
        action: Actions.Void,
    };

    private processingThenBookingItem: IBreadcrumbItem = {
        name: this.labels[Actions.Booking],
        isActive: false,
        isClickable: false,
        action: Actions.Booking,
    };

    private ticketReportItem: IBreadcrumbItem = {
        name: this.labels[Actions.Search],
        isActive: false,
        isClickable: false,
        action: Actions.Search,
        routerLink: ['/sasha', 'ticketing-report']
    };
    private processReportItem: IBreadcrumbItem = {
        name: this.labels[Actions.Search],
        isActive: false,
        isClickable: false,
        action: Actions.Search,
        routerLink: ['/sasha', 'process-report']
    };

    private bookingInTicketingReportItem: IBreadcrumbItem = {
        name: this.labels[Actions.Search],
        isActive: false,
        isClickable: false,
        action: Actions.Search,
        routerLink: ['/sasha', 'booking-in-ticketing-report']
    };

    private bookingInTicketingReportResultItem: IBreadcrumbItem = {
        name: this.labels[Actions.Results],
        isActive: false,
        isClickable: false,
        action: Actions.Results,
        routerLink: ['/sasha', 'booking-in-ticketing-report', 'search-result']
    };

    private processingImportItem: IBreadcrumbItem = {
        name: this.labels[Actions.import],
        isActive: false,
        isClickable: false,
        action: Actions.import,
        routerLink: ['/sasha', 'import-booking']
    };

    //////////////////////////////////// CONSTRUCTOR ////////////////////////////////////

    constructor(
        private readonly breadcrumbService: BreadcrumbService
    ) {
    }

    //////////////////////////////////// SERVICE METHODS ////////////////////////////////////

    public getItems(): IBreadcrumbItem[] {
        return this.breadcrumbService.getItems();
    }

    /* BOOKING METHODS */

    public setSearch(parameters: BookingSearchParameters): void {
        const queryParams: object = parameters.convertToUrlParameters();
        let isClickable: boolean = false;

        if (_isEqual(queryParams, this.bookingSearchItem.queryParams)) {
            isClickable = true;
        }
        if (_isEqual(queryParams, this.processingSearchItem.queryParams)) {
            isClickable = true;
        }

        const isBookingClickable: boolean = Boolean(isClickable && this.bookingItem.routerLink);
        const routerLink: string[] = isBookingClickable ? this.bookingItem.routerLink : undefined;

        this.bookingSearchItem = { ...this.bookingSearchItem, isActive: true, isClickable: false, queryParams };

        if (this.bookingResultItem.isActive || this.bookingResultItem.isClickable) {
            this.bookingResultItem = { ...this.bookingResultItem, isActive: false, isClickable: true, queryParams };
        }
        this.bookingItem = {
            ...this.bookingItem,
            isActive: false,
            isClickable: isBookingClickable,
            routerLink
        };

        this.setItems();
    }


    public setSearchResult(parameters: BookingSearchParameters): void {
        const queryParams: object = parameters.convertToUrlParameters();
        let isClickable: boolean = false;

        if (_isEqual(queryParams, this.bookingSearchItem.queryParams)) {
            isClickable = true;
        }

        const isBookingClickable: boolean = Boolean(isClickable && this.bookingItem.routerLink);
        const routerLink: string[] = isBookingClickable ? this.bookingItem.routerLink : undefined;

        this.bookingSearchItem = {
            ...this.bookingSearchItem,
            isActive: false,
            isClickable: true,
            queryParams
        };
        this.bookingResultItem = {
            ...this.bookingResultItem,
            isActive: true,
            isClickable: false,
            queryParams
        };
        this.bookingItem = {
            ...this.bookingItem,
            isActive: false,
            isClickable: isBookingClickable,
            routerLink
        };

        this.setItems();
    }


    public setBooking(bookingSyscode: string): void {
        if (this.bookingSearchItem.isActive || this.bookingSearchItem.isClickable) {
            this.bookingSearchItem = { ...this.bookingSearchItem, isActive: false, isClickable: true };
        }
        if (this.bookingResultItem.isActive || this.bookingResultItem.isClickable) {
            this.bookingResultItem = { ...this.bookingResultItem, isActive: false, isClickable: true };
        }
        this.bookingItem = {
            ...this.bookingItem,
            isActive: true,
            isClickable: false,
            routerLink: ['/sasha', 'booking', bookingSyscode]
        };

        this.setItems();
    }

    // TICKETING REPORT METHODS

    public setTicketingReportSearch(): void {
        this.ticketReportItem = {
            ...this.ticketReportItem,
            isActive: true,
            isClickable: false,
        };
        this.setItems();
    }
    // TICKETING REPORT METHODS

    public setProcessReportSearch(): void {
        this.processReportItem = {
            ...this.processReportItem,
            isActive: true,
            isClickable: false,
        };
        this.setItems();
    }

    // BOOKING IN TICKETING REPORT METHODS

    public setBookingInTicketingReportSearch(queryParams: IBookingInTicketingReportSearchParametersUrl): void {
        this.bookingInTicketingReportItem = {
            ...this.bookingInTicketingReportItem,
            isActive: true,
            isClickable: false,
            queryParams,
        };

        if (queryParams.ag && queryParams.s) {
            this.bookingInTicketingReportResultItem = {
                ...this.bookingInTicketingReportResultItem,
                queryParams,
                isClickable: true,
                isActive: false
            };
        } else {
            this.bookingInTicketingReportResultItem = {
                ...this.bookingInTicketingReportResultItem,
                isActive: false,
                isClickable: false,
            };
        }

        this.setItems();
    }

    public setBookingInTicketingReportResult(queryParams: IBookingInTicketingReportSearchParametersUrl): void {
        this.bookingInTicketingReportItem = {
            ...this.bookingInTicketingReportItem,
            isActive: false,
            isClickable: true,
            queryParams,
        };

        this.bookingInTicketingReportResultItem = {
            ...this.bookingInTicketingReportResultItem,
            isActive: true,
            isClickable: false,
        };

        this.setItems();
    }

    // PROCESSING METHODS

    public setProcessingSearch(parameters: ProcessingSearchParameters): void {
        const queryParams: object = parameters.convertToUrlParameters();
        let isClickable: boolean = false;


        if (_isEqual(queryParams, this.processingSearchItem.queryParams)) {
            isClickable = true;
        }

        const isProcessingClickable: boolean = Boolean(isClickable && this.processingItem.isClickable);
        const routerLink: string[] = isProcessingClickable ? this.processingItem.routerLink : undefined;

        this.processingSearchItem = { ...this.processingSearchItem, isActive: true, isClickable: false, queryParams };
        if (this.processingResultItem.isActive || this.processingResultItem.isClickable) {
            this.processingResultItem = { ...this.processingResultItem, isActive: false, isClickable, queryParams };
        }
        this.processingItem = {
            ...this.processingItem,
            isActive: false,
            isClickable: isProcessingClickable,
            routerLink
        };

        this.setItems();
    }


    public setProcessingSearchResult(parameters: ProcessingSearchParameters): void {
        const queryParams: object = parameters.convertToUrlParameters();
        let isClickable: boolean = false;

        if (_isEqual(queryParams, this.processingSearchItem.queryParams)) {
            isClickable = true;
        }

        const isProcessingClickable: boolean = Boolean(isClickable && this.processingItem.routerLink);
        const routerLinkProcessing: string[] = isProcessingClickable ? this.processingItem.routerLink : undefined;
        const routerLinkProcessingThenBooking: string[] =
            isProcessingClickable ? this.processingThenBookingItem.routerLink : undefined;

        this.processingSearchItem = { ...this.processingSearchItem, isActive: false, isClickable: true, queryParams };
        this.processingResultItem = { ...this.processingResultItem, isActive: true, isClickable: false, queryParams };
        this.processingItem = {
            ...this.processingItem,
            isActive: false,
            isClickable: isProcessingClickable,
            routerLink: routerLinkProcessing
        };
        this.processingThenBookingItem = {
            ...this.processingThenBookingItem,
            isActive: false,
            isClickable: isProcessingClickable,
            routerLink: routerLinkProcessingThenBooking
        };

        this.setItems();
    }


    public setProcessing(id: string): void {

        let isBookingClickable: boolean = false;

        const processingIdFromBooking: string = _get(this.processingThenBookingItem, 'processingId');

        if (processingIdFromBooking === id && _get(this.processingThenBookingItem, 'routerLink')) {
            isBookingClickable = true;
        }
        if (this.processingSearchItem.isActive || this.processingSearchItem.isClickable) {
            this.processingSearchItem = {
                ...this.processingSearchItem,
                isActive: false,
                isClickable: true
            };
        }
        if (this.processingResultItem.isActive || this.processingResultItem.isClickable) {
            this.processingResultItem = {
                ...this.processingResultItem,
                isActive: false,
                isClickable: true
            };
        }

        this.processingItem = {
            ...this.processingItem,
            isActive: true,
            isClickable: false,
            routerLink: ['/sasha', 'processing', id]
        };

        this.processingThenBookingItem = {
            ...this.processingThenBookingItem,
            isActive: false,
            isClickable: isBookingClickable,
            processingId: id.toString()
        };
        this.setItems();
    }

    public setProcessingThenBooking(processingId: number, bookingSyscode: string): void {
        if (this.processingSearchItem.isClickable || this.processingSearchItem.isActive) {
            this.processingSearchItem = {
                ...this.processingSearchItem,
                isActive: false,
                isClickable: true
            };
        }

        if (this.processingResultItem.isClickable || this.processingResultItem.isActive) {
            this.processingResultItem = {
                ...this.processingResultItem,
                isActive: false,
                isClickable: true
            };
        }

        this.processingItem = {
            ...this.processingItem,
            isActive: false,
            isClickable: true,
            routerLink: ['/sasha', 'processing', processingId.toString()]
        };

        this.processingThenBookingItem = {
            ...this.processingThenBookingItem,
            isActive: true,
            isClickable: false,
            routerLink: ['/sasha', 'processing', processingId.toString(), 'booking', bookingSyscode],
            processingId: processingId.toString(),
        };

        this.setItems();
    }

    public setQualityCheckItems(): void {
        this.bookingSearchItem = {
            ...this.bookingSearchItem,
            isActive: false,
            isClickable: true
        };

        this.bookingResultItem = {
            ...this.bookingResultItem,
            isActive: false,
            isClickable: true
        };

        this.processingQualityCheckItem = {
            ...this.processingQualityCheckItem,
            isActive: true,
            isClickable: false,
            routerLink: ['/sasha', 'processing-qualityCheck']
        };

        this.setItems();
    }

    public setIssuingItems(): void {
        this.bookingSearchItem = {
            ...this.bookingSearchItem,
            isActive: false,
            isClickable: true
        };

        this.bookingResultItem = {
            ...this.bookingResultItem,
            isActive: false,
            isClickable: true
        };

        this.processingIssueItem = {
            ...this.processingIssueItem,
            isActive: true,
            isClickable: false,
            routerLink: ['/sasha', 'processing-issuing']
        };

        this.setItems();
    }

    public setCancellationItems(): void {
        this.bookingSearchItem = {
            ...this.bookingSearchItem,
            isActive: false,
            isClickable: true
        };

        this.bookingResultItem = {
            ...this.bookingResultItem,
            isActive: false,
            isClickable: true
        };

        this.processingCancelItem = {
            ...this.processingCancelItem,
            isActive: true,
            isClickable: false,
            routerLink: ['/sasha', 'processing-cancellation']
        };

        this.setItems();
    }

    public setProcessingImport(): void {
        this.processingImportItem = {
            ...this.processingImportItem,
            isActive: true,
            isClickable: false,
        };

        this.setItems();
    }

    /* general */

    public setItems(): void {

        switch (this.context) {
            case SashaEntryPoints.booking:
                this.setBookingItems();
                break;
            case SashaEntryPoints.processing:
                this.setProcessingItems();
                break;
            case SashaEntryPoints.processingCancel:
                this.setCancelItems();
                break;
            case SashaEntryPoints.ticketingReport:
                this.setTicketReportItems();
                break;
            case SashaEntryPoints.bookingInTicketingReport:
                this.setBookingInTicketingReportItems();
                break;
            case SashaEntryPoints.importBooking:
                this.setProcessingImportItems();
                break;
            case SashaEntryPoints.processReport:
                this.setProcessReportItems();
                break;
            default:
                this.setBookingItems();
                break;
        }
    }

    public setTicketReportItems(): void {
        const list: IBreadcrumbItem[] = [];

        if (this.ticketReportItem.isClickable || this.ticketReportItem.isActive) {
            list.push(this.ticketReportItem);
        }

        if (this.bookingInTicketingReportResultItem.isClickable || this.bookingInTicketingReportResultItem.isActive) {
            list.push(this.bookingInTicketingReportResultItem);
        }

        this.breadcrumbService.setItems(list);
    }
    public setProcessReportItems(): void {
        const list: IBreadcrumbItem[] = [];

        if (this.processReportItem.isClickable || this.processReportItem.isActive) {
            list.push(this.processReportItem);
        }
        this.breadcrumbService.setItems(list);
    }

    public setProcessingImportItems(): void {
        const list: IBreadcrumbItem[] = [];

        if (this.processingImportItem.isClickable || this.processingImportItem.isActive) {
            list.push(this.processingImportItem);
        }

        this.breadcrumbService.setItems(list);
    }

    public setBookingItems(): void {
        const list: IBreadcrumbItem[] = [];

        if (this.bookingSearchItem.isClickable || this.bookingSearchItem.isActive) {
            list.push(this.bookingSearchItem);
        }
        if (this.bookingResultItem.isClickable || this.bookingResultItem.isActive) {
            list.push(this.bookingResultItem);
        }
        if (this.bookingItem.isClickable || this.bookingItem.isActive) {
            list.push(this.bookingItem);
        }

        this.breadcrumbService.setItems(list);
    }

    public setProcessingItems(): void {
        const list: IBreadcrumbItem[] = [];

        if (this.processingSearchItem.isClickable || this.processingSearchItem.isActive) {
            list.push(this.processingSearchItem);
        }
        if (this.processingResultItem.isClickable || this.processingResultItem.isActive) {
            list.push(this.processingResultItem);
        }

        if (this.processingItem.isClickable || this.processingItem.isActive) {
            list.push(this.processingItem);
        }

        if (this.processingThenBookingItem.isClickable || this.processingThenBookingItem.isActive) {
            list.push(this.processingThenBookingItem);
        }


        this.breadcrumbService.setItems(list);
    }

    public setVoidingItems(): void {
        this.bookingSearchItem = {
            ...this.bookingSearchItem,
            isActive: false,
            isClickable: true
        };

        this.bookingResultItem = {
            ...this.bookingResultItem,
            isActive: false,
            isClickable: true
        };

        this.processingVoidItem = {
            ...this.processingVoidItem,
            isActive: true,
            isClickable: false,
            routerLink: ['/sasha', 'processing-voiding']
        };

        this.setItems();
    }

    public setContext(contextName: string): void {
        this.context = contextName;
    }

    private setCancelItems(): void {
        const list: IBreadcrumbItem[] = [this.bookingSearchItem];

        if (this.bookingResultItem.isClickable || this.bookingResultItem.isActive) {
            list.push(this.bookingResultItem);

            if (this.bookingItem.isClickable || this.bookingItem.isActive) {
                list.push(this.bookingItem);
            }

            if (this.processingCancelItem.isClickable || this.processingCancelItem.isActive) {
                list.push(this.processingCancelItem);
            }
        }

        this.breadcrumbService.setItems(list);
    }

    private setBookingInTicketingReportItems(): void {
        const list: IBreadcrumbItem[] = [this.bookingInTicketingReportItem];
        if (this.bookingInTicketingReportResultItem.isActive) {
            list.push(this.bookingInTicketingReportResultItem);
        }

        this.breadcrumbService.setItems(list);
    }
}
